import { TerminalUpdateMessage } from '../models/types/terminals-model.types';
import { authFetchGET, authFetchPOST } from '../utils/auth-fetch';
import { IndexedDBService } from '../../indexed-db/services/db_service';
import { isOnline } from '../utils/helpers';

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;
const terminalsApi = (<any>window).appenv.services.terminals;
const env = { ...terminalsApi, ...isVesselOnCloud ? { scope: (<any>window)["appenv"].scope } : {} };

export interface PilotInfo
{
    terminalCode: string;
    timeToPilotInSeconds: number|null;
    timeToBerthInSeconds: number|null;
}

export class TerminalsService {
    static async fetchAllTerminalsData() {
        return await authFetchGET(env.scope, `${env.baseurl}/v1/terminals`);
    }

    static async getTerminalLocaltime(terminalId: string, utc: string): Promise<string> {
        const result = await authFetchGET(env.scope, `${env.baseurl}/v1/terminals/${terminalId}/timeToLocal/${utc}`);
        return result.convertedTime;
    }

    static async getTerminalLocaltimeBatch(timestampsAndTerminals: Array<{timestamp: String, terminalId: String}>): Promise<string[]>
    {
        if (isVesselOnCloud) {
            // supports offline mode with IndexedDB caching
            let result;
            if (isOnline()){
                result = await authFetchPOST(env.scope, `${env.baseurl}/v1/terminals/batchTimeToLocal`, timestampsAndTerminals);
                await IndexedDBService.batchTimeToLocal.addAll(result?.results);
            } else {
                const localBatchTime = await IndexedDBService.batchTimeToLocal.getAll();
                result = {
                    results: localBatchTime
                }
            }
            return result.results.map( (x: {inputTime: string, convertedTime: string}) => x.convertedTime );
        } else {
            // no IndexedDB caching
            const result = await authFetchPOST(env.scope, `${env.baseurl}/v1/terminals/batchTimeToLocal`, timestampsAndTerminals);
            return result.results.map( (x: {inputTime: string, convertedTime: string}) => x.convertedTime );
        }
    }

    static async getUTCFromTerminalLocaltime(terminalId: string, local: string): Promise<string>
    {
        const result = await authFetchGET(env.scope, `${env.baseurl}/v1/terminals/${terminalId}/timeToUTC/${local}`);
        return result.convertedTime;
    }

    static async getTerminalPortMemo(terminalId: string) {

        const portMemoURL = isVesselOnCloud ? `/portmemosapi/v1/portmemos/all/${terminalId}` : `${env.baseurl}/v2/terminals/${terminalId}/portmemo`;
        return await authFetchGET(env.scope, portMemoURL);
    }

    static async getTerminalPilotInfo(terminalId: string): Promise<PilotInfo> {
        return await authFetchGET(env.scope, `${env.baseurl}/v1/terminals/${terminalId}/pilot`);
    }

    static async createTerminal(terminal: TerminalUpdateMessage)
    {
        const TerminalUpdate = {
            terminalId: terminal.locationId,
            terminal: terminal,
            updated: new Date().toISOString(),
            deleted: false
        }

        const TerminalVesselMessage = {
            terminals: [TerminalUpdate]
        }

        return await authFetchPOST(env.scope, `${env.baseurl}/v1/terminals`, TerminalVesselMessage)
    }

    static async getAllTerminalsPortMemos(terminalIds: string[] = []): Promise<any> {
        if (terminalIds.length > 0) {
            // only for cloud vessels
            const terminalIdsList = [...new Set(terminalIds)];
            const terminalIdsArray = terminalIdsList.join(',');
            const portMemoURL = `/portmemosapi/v2/portmemos/all?terminal_ids=${terminalIdsArray}`;
            return await authFetchGET(env.scope, portMemoURL);
        }
    }
}
